<template>
  <div>
    <v-card color="white"
            class="ga-4 pa-2">
      <v-text-field v-model="customerProject.customer.name"
                    label="Name"
                    placeholder="John Doe"
                    name="name"
                    variant="solo-filled"
                    required></v-text-field>

      <v-text-field v-model="customerProject.customer.address"
                    label="Address"
                    placeholder="123 Main St"
                    name="address"
                    variant="solo-filled"></v-text-field>

      <div class="d-flex flex-wrap flex-column flex-md-row justify-content-between ga-0 ga-md-2">
        <v-text-field v-model="customerProject.customer.city"
                      label="City"
                      placeholder="Enter city"
                      name="city"
                      variant="solo-filled"
                      :class="[display.mobile ? 'w-auto' : 'w-33','w-auto']"></v-text-field>
        <div :class="[display.mobile ? 'w-auto' : 'w-66', 'd-flex ga-2']" >
          <v-select v-model="customerProject.customer.state"
                    :items="US_STATES"
                    label="State"
                    
                    placeholder="Select state"
                    name="state"
                    variant="solo-filled"
                    required
                    class="flex-grow-1"></v-select>

          <v-text-field v-model="customerProject.customer.zip"
                        label="Zip"
                        placeholder="Enter zip code"
                        name="zip"
                        variant="solo-filled"
                        class="flex-grow-1"></v-text-field>
        </div>
      </div>

      <v-text-field v-model="customerProject.customer.email"
                    :rules="[validateEmail]"
                    validate-on="blur"
                    label="Email"
                    placeholder="johndoe@test.com"
                    name="email"
                    variant="solo-filled"
                    type="email"
                    required></v-text-field>

      <v-text-field v-model="customerProject.customer.phone"
                    :rules="[validatePhone]"
                    validate-on="blur"
                    label="Phone"
                    placeholder="(123) 456-7890"
                    name="phone"
                    variant="solo-filled"
                    type="tel"
                    required></v-text-field>

      <v-select v-model="customerProject.preferredContact"
                :items="['text', 'phone', 'email']"
                label="Preferred Contact Method"
                name="preferredContact"
                variant="solo-filled"
                required></v-select>
    </v-card>
  </div>
</template>

<script lang="ts" setup>
import { ContactMethod, type ContactModel } from '~/models/contactModel';
import { US_STATES } from '~/constants/states';
import { useDisplay } from 'vuetify';

const display = ref(useDisplay());

const customerProject = defineModel<ContactModel>({
  default: { customer: { name: '', address: '', city: '', state: '', zip: '', email: '', phone: '' }, preferredContact: '' },
});
// Helper validation methods
function validateEmail() {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (customerProject.value?.preferredContact === ContactMethod.Email) {
    return emailRegex.test(customerProject.value?.customer.email) || 'Enter a valid email';
  }
  return true;
}

function validatePhone() {
  if (
    customerProject.value?.preferredContact === ContactMethod.Phone ||
    customerProject.value?.preferredContact === ContactMethod.Text
  ) {
    return !!customerProject.value?.customer.phone || 'Phone is required';
  }
  return true;
}
</script>

<style scoped>
/* Add your custom styles here */
</style>